<template>
  <div class="company-credit-record-new">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="newForm" :model="companyModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <FormItem label="类型" prop="type">
            <RadioGroup v-model="companyModel.type" type="button">
              <Radio :label="1">失信记录</Radio>
              <Radio :label="0">履约记录</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="企业名称" prop="companyName">
            <Select
              v-model="companyModel.companyName"
              filterable
              remote
              clearable
              @on-select="selectCompany"
              @on-clear="clearCompany"
              placeholder="输入企业名称"
              :remote-method="searchCompany"
              :loading="loading">
              <Option v-for="(option, index) in companies" :value="option.name" :tag="option.tid" :key="index">{{option.name}}</Option>
            </Select>
          </FormItem>
          <FormItem label="企业类型" prop="companyType">
            <Select v-model="companyModel.companyType" filterable>
              <Option v-for="(tp,idx) in $common.getEnumSelect($common.companyType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="项目名称" prop="projectName">
            <Select
              v-model="companyModel.projectName"
              filterable
              remote
              clearable
              @on-select="selectGuarantee"
              @on-clear="clearGuarantee"
              placeholder="输入项目名称"
              :remote-method="searchGuarantees"
              :loading="loading">
              <Option v-for="(option, index) in guarantees" :value="option.prjName" :tag="option.id" :key="index">{{option.prjName}}</Option>
            </Select>
            <!-- <Select
              v-model="companyModel.projectName"
              filterable
              remote
              clearable
              @on-select="selectProject"
              @on-clear="clearProject"
              placeholder="输入项目名称"
              :remote-method="searchProjects"
              :loading="loading">
              <Option v-for="(option, index) in projects" :value="option.name" :tag="option.tid" :key="index">{{option.name}}</Option>
            </Select> -->
          </FormItem>
          <FormItem label="发布日期" prop="publishDate">
            <Date-picker type="date" :value="companyModel.publishDate" @on-change="changePublishDate" placeholder="YYYY-MM-DD" style="width: 150px"></Date-picker>
          </FormItem>
          <FormItem label="原因" prop="reason">
            <Input type="textarea" :autosize="{ minRows: 5 }" v-model="companyModel.reason" placeholder="输入原因" />
          </FormItem>
          <FormItem label="主要事实" prop="fact">
            <Input type="textarea" :autosize="{ minRows: 5 }" v-model="companyModel.fact" placeholder="输入主要事实" />
          </FormItem>
          <FormItem label="处置结果" prop="conclusion">
            <Input type="textarea" :autosize="{ minRows: 5 }" v-model="companyModel.conclusion" placeholder="输入处置结果" />
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
export default {
  name: 'company-credit-record-new',
  props: {
  },
  data () {
    return {
      loading: false,
      guarantees: [],
      projects: [],
      companies: [],
      companyModel: {
        companyName: null,
        companyId: null,
        companyType: null,
        companyBusinessLicense: null,
        projectId: null,
        projectName: null,
        type: 1,
        guaranteeId: null,
        reason: null,
        fact: null,
        conclusion: null,
        publishDate: null
      },
      modelValidate: {
        type: [
          { required: true, type: 'number', message: '请选择类型', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请填写企业名称', trigger: 'blur' }
        ],
        companyBusinessLicense: [
          { required: true, message: '请填写企业社会信用代码', trigger: 'blur' }
        ],
        projectName: [
          { required: true, message: '请填写项目名称', trigger: 'blur' }
        ],
        companyType: [
          { required: true, type: 'number', message: '请选择企业类型', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '请填写原因', trigger: 'blur' }
        ],
        publishDate: [
          { required: true, type: 'date', message: '请填写发布日期', trigger: 'change' },
        ],
      },
    }
  },
  watch: {
  },
  mounted () {
    this.companyModel.publishDate = new Date()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    changePublishDate (date) {
      this.companyModel.publishDate = this.$moment(date).format('YYYY-MM-DD')
    },
    clearGuarantee () {
      this.companyModel.projectId = null
      this.companyModel.projectName = null
      this.companyModel.guaranteeId = null
    },
    selectGuarantee (project) {
      try {
        if (project.tag) {
          let item = this.guarantees.find(o => o.id === project.tag)
          this.companyModel.guaranteeId = item.id
          this.companyModel.projectId = item.prjId
          this.companyModel.projectName = project.value
        } else {
          this.clearGuarantee()
        }
      } catch (e) {
        console.log(e)
        this.clearGuarantee()
      }
    },
    searchGuarantees (query) {
      this.$Api.Guarantee.listGuarantees({
        prjName: query,
        statusList: [1]
      }, 1, 1000).then((prjs) => {
        this.guarantees = prjs.data
      }).catch(err => {
        this.$Message.error('获取项目列表失败!' + err.message)
      })
    },
    clearProject () {
      this.companyModel.projectId = null
      this.companyModel.projectName = null
    },
    selectProject (project) {
      try {
        if (project.tag) {
          this.companyModel.projectId = project.tag
          this.companyModel.projectName = project.value
        } else {
          this.clearProject()
        }
      } catch (e) {
        console.log(e)
        this.clearProject()
      }
    },
    searchProjects (query) {
      this.$Api.Project.searchProjects({
        name: query
      }, 1, 1000).then((prjs) => {
        this.projects = prjs.data
      }).catch(err => {
        this.$Message.error('获取项目列表失败!' + err.message)
      })
    },
    clearCompany () {
      this.companyModel.companyId = null
      this.companyModel.companyName = null
      this.companyModel.companyType = null
    },
    selectCompany (company) {
      // console.log(company, typeof(company.value))
      try {
        if (company.tag) {
          this.companyModel.companyId = company.tag
          this.companyModel.companyName = company.value
          let companyItem = this.companies.find(o => o.tid === company.tag)
          this.companyModel.companyType = companyItem.type
          this.companyModel.companyBusinessLicense = companyItem.businessLicense
        } else {
          this.clearCompany()
        }
      } catch (e) {
        console.log(e)
        this.clearCompany()
      }
    },
    searchCompany (query) {
      this.loading = true
      this.$Api.Company.listCompanies({
        isLocal: null,
        name: query,
        type: null
      }, 1, -1).then((companies) => {
        this.companies = companies.data
        this.loading = false
      }).catch(err => {
        this.$Message.error('获取列表失败!' + err.message)
        this.loading = false
      })
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await this.$Api.CompanyCreditRecord.addCompanyCreditRecord(this.companyModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.companyModel= {
                companyName: null,
                companyId: null,
                companyType: null,
                companyBusinessLicense: null,
                projectId: null,
                projectName: null,
                type: 1,
                guaranteeId: null,
                reason: null,
                fact: null,
                conclusion: null,
                publishDate: new Date()
              }
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
